var documentDirectives = angular.module ( 'documentDirectives' , [ 'bookModule' , 'documentFilters' ] );

documentDirectives
.directive('removeKenticoMarkup', 
    ['$http', 'contentService', 
    function ($http, contentService) {
        return {
            restrict : 'A',
            scope : {
                extractHtmlSnippetFunc : '&',
                includeUrl: '=',
                callback: '&'
            },
            link: function (scope, element, attrs) {
                /** checks to see if there is a div Kentico
                */
                var contentPromise = $http.get(scope.includeUrl)
                    .then(function (response) {
                        /** replace the contents of the ng-include with the HtmlSnippet contents.
                         * If the HtmlSnippet cannot be found then replace it with null
                        */
                        var htmlSnippetContents = contentService.extractKenticoContentFromString(response.data, false);
                        element[0].innerHTML = htmlSnippetContents;

                        scope.callback();
                    });
            }
        };
    }]
);

documentDirectives
.directive ( 'titleWithDictionaryLinks' , function () {
    return {
        restrict : 'E' ,
        template : '<span ng-repeat="titlePart in titleWithLinksArray"><span ng-if="!titlePart.isLink">{{ titlePart.text }}</span><a ng-if="titlePart.isLink" ui-sref="matrix.dictionary ({ chapterString: currentChapter, pathwayString: currentPathway , dictionaryTerm: (titlePart.text|convertStringToUrl) })">{{ titlePart.text }}</a></span>',
        scope : {
            titleString : '=' ,
            currentChapter : '=' ,
            dictionaryTermsArray : '=' ,
            currentPathway : '=' ,
            scrollToIdFunc : '&' ,
        } ,
        controller : [ '$scope', 
            function ( $scope ) {
                //const
                const idOfAnchor = "dictionaryDefinitionAnchor";
                $scope.idOfAnchor = idOfAnchor

                // add delimeters around the different parts in the title
                var tempTitleString = $scope.titleString;
                var delimiter = ';';

                if (!Array.isArray($scope.dictionaryTermsArray))
                {
                    //console.log("No dictionary terms for: '"+$scope.titleString+"'");
                    var titlePart = {};
                    titlePart.text = $scope.titleString;
                    return;
                }
                // make sure that the dictionary terms are all lower case
                var dictionaryTermsLowercaseArray = $scope.dictionaryTermsArray.map(function(value) {
                  return value.toLowerCase();
                });

                dictionaryTermsLowercaseArray.forEach(function(dictionaryTerm) {
                    var escapedDictionaryTerm = dictionaryTerm.replace(/([()])/g, '\\$1');
                    var regex = new RegExp('('+escapedDictionaryTerm+')', "gi");
                    tempTitleString = tempTitleString.replace(regex, delimiter + '$1' + delimiter);
                } );

                // remove trailing delimiters
                var regex = new RegExp(delimiter+'$',"g");
                tempTitleString = tempTitleString.replace(regex, "");
                regex = new RegExp('^'+delimiter,"g");
                tempTitleString = tempTitleString.replace(regex, "");

                // split the parts of the title up
                var tempTitlePartsArray = tempTitleString.split(delimiter);

                // add the parts of the title to the list
                $scope.titleWithLinksArray = [];
                tempTitlePartsArray.forEach(function(tempTitlePart) {
                    var titlePart = {};
                    titlePart.text = tempTitlePart;
                    titlePart.isLink = dictionaryTermsLowercaseArray.indexOf(tempTitlePart.toLowerCase()) > -1;
                    $scope.titleWithLinksArray.push(titlePart);
                } );
            }
        ]
    }
} ) ;

documentDirectives
.directive("angularMetaKeywords",function(){
    return {
        restrict: "E",
        scope: {
            currentPathway: '=',
            currentNode: '=',
            currentDictionaryTerm: '=', 
        },
        replace: false,
        link: function(scope) {
            // set the default meta description
            var metaDescription = "RACGP Curriculum Core Skills.";

            // if the current node is not undefined then we can populate the meta with the chapter and title
            if (typeof scope.currentNode !== 'undefined') {
                var chapter = scope.currentNode.chapter;
                var uppercaseChapterName = chapter[0].toUpperCase() + chapter.slice(1);
                metaDescription = uppercaseChapterName + ": " + scope.currentNode.title + ". ";          
            }

            // check if there is currently a description metatag
            var existingMetaTag = document.getElementsByName('description')[0];
            if (!existingMetaTag)
            {
                var newMetaTag = document.createElement('meta');
                newMetaTag.name = "description";
                document.getElementsByTagName('head')[0].appendChild(newMetaTag);
                existingMetaTag = document.getElementsByName('description')[0];
            }
            // add/update the description metatag
            existingMetaTag.content = metaDescription;
        }   
   }
});